import React from "react";
import "../styles.css";
import ArtishPostList from '../components/ArtistPostList'
import FacebookFeed from "../components/Facebookfeed";


const Home = () => {
  return (
    <div className="page-container">
      <h1>Latest News</h1>
      <p className="contact">
        Need to reach us? <a href="mailto:info@xfiremusic.com.au">info@xfiremusic.com.au</a>
      </p>
      
      <ArtishPostList artistPageId={12}/>
    </div>
  );
};

export default Home;
